import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LibModuleModule } from "./lib-module/lib-module.module";

@NgModule({
  imports: [CommonModule, LibModuleModule],
  exports: [LibModuleModule]
})
export class BreadcrumbProgressModule {}
